import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { register, registrationStatus } from '../api/authApi';
import { useAuth } from '../context/AuthContext';

const RegisterPage = () => {
  const [form, setForm] = useState({ displayName: '', username: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [registrationMode, setRegistrationMode] = useState('open');
  const { storeTokens } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const inviteToken = useMemo(() => searchParams.get('invite') || '', [searchParams]);
  const canRegister = registrationMode === 'open' || (registrationMode === 'invite' && Boolean(inviteToken));

  useEffect(() => {
    const loadRegistrationMode = async () => {
      try {
        const { data } = await registrationStatus();
        setRegistrationMode(data.mode || 'open');
      } catch {
        setRegistrationMode('open');
      }
    };

    loadRegistrationMode();
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canRegister) {
      setError('Registration is currently invite-only during beta.');
      return;
    }

    setError('');
    try {
      const payload = inviteToken ? { ...form, inviteToken } : form;
      const { data } = await register(payload);
      storeTokens(data.accessToken, data.refreshToken, data.user);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    }
  };

  return (
    <div className="auth-page">
      <h1>Necronomicon</h1>
      <form onSubmit={handleSubmit} className="auth-form">
        <h2>Create Account</h2>
        {registrationMode === 'invite' && !inviteToken && (
          <p>Registration is invite-only during beta. Use your invite link to continue.</p>
        )}
        {registrationMode === 'closed' && (
          <p>Registration is currently closed. Please contact an admin for access.</p>
        )}
        {error && <p className="error">{error}</p>}
        <input name="displayName" placeholder="Display Name" value={form.displayName} onChange={handleChange} required />
        <input name="username" placeholder="Username (3-20 chars, a-z 0-9 _)" value={form.username} onChange={handleChange} required />
        <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required />
        <input name="password" type="password" placeholder="Password" value={form.password} onChange={handleChange} required />
        <button type="submit" disabled={!canRegister}>Join the Dark Arts</button>
        <p>Have an account? <Link to="/login">Login</Link></p>
      </form>
    </div>
  );
};

export default RegisterPage;
